import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/chat")({
  staticData: {
    breadcrumb: "Chat History",
  },
  component: () => <Outlet />,
});
